import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import HeaderButton from 'li-components/lib/HeaderButton'
import vars from 'li-components/lib/styles'

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  display: ${p => (p.userMenuOpen ? 'flex' : 'none')};
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  padding-right: 20px;
  padding-left: 75px;
  background: 0;
  border: 0;
  outline: 0;

  @media screen and (max-width: ${vars.screenMd}) {
    display: flex;
    right: ${p => (p.userMenuOpen || !p.loggedIn ? 0 : '6rem')};
  }
`

const ifOpen = (a, b) => p => (p.open ? a : b)

export const Button = styled(HeaderButton)`
  display: flex;
  justify-content: center;
  align-items: stretch;
  align-content: center;
  flex-direction: column;
  padding: 0 10px;

  > div {
    width: 100%;
    height: 3px;
    background-color: ${vars.grayDarker};
    border-radius: 2px;

    &:not(:first-child) {
      margin-top: 2px;
    }

    &:nth-of-type(1) {
      transform: ${ifOpen('rotate(45deg) translate(25%, 100%)', 'none')};
      transition: transform 0.1s;
    }

    &:nth-of-type(2) {
      opacity: ${ifOpen(0, 1)};
      transition: scale 0.2s, opacity 0.2s;
    }

    &:nth-of-type(3) {
      transform: ${ifOpen('rotate(-45deg) translate(27%, -118%)', 'none')};
      transition: transform 0.1s;
    }
  }
`

const Hamburger = ({ mobileMenuOpen, userMenuOpen, ...rest }) => (
  <Container className="MenuButton" userMenuOpen={userMenuOpen} {...rest}>
    <Button open={mobileMenuOpen}>
      <div />
      <div />
      <div />
    </Button>
  </Container>
)

Hamburger.propTypes = {
  userMenuOpen: PropTypes.bool.isRequired,
  mobileMenuOpen: PropTypes.bool.isRequired,
  loggedIn: PropTypes.bool.isRequired,
}

export default Hamburger



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Hamburger.js